(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("addExternalLogin", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/registration/externalLoginConfigurations/add/addExternalLoginView.html",
            controller: ["$state", "$translate", "externalLoginConfigurationResource", "groupHierarchyResource", "$uibModal", "messageService", "$timeout", "_", "$http", AddExternalLoginCtrl],
            controllerAs: "vm"
        };
        function AddExternalLoginCtrl($state, $translate, externalLoginConfigurationResource, groupHierarchyResource, $uibModal, messageService, $timeout, _, $http) {
            var vm = this;
            vm.step = 1;
            vm.nextButtonText = "common.next";
            vm.showErrors = false;
            vm.confirmButtonEnabled = true;
            vm.wellKnownInvalid = false;
            vm.externalLoginProviders = [];
            vm.mappings = [{ from: "", to: "" }];
            vm.isLoading = true;
            externalLoginConfigurationResource.getExternalLoginFormViewModel(function (result) {
                vm.externalLoginProviders = result.providers;
                vm.fieldsToMap = result.fieldsToMap;
                vm.selfRegistrationGroupId = result.selfRegistrationGroupId;
                loadGroups();
            });
            function loadGroups() {
                groupHierarchyResource.query({ showAllGroups: false }, function (data) {
                    vm.availableGroups = data;
                    if (vm.selfRegistrationGroupId) {
                        vm.selectedGroup = _.find(vm.availableGroups, { "id": vm.selfRegistrationGroupId });
                    }
                });
            }
            vm.groupChanged = function () {
                if (vm.selectedGroup)
                    vm.formData.signUpConfiguration.groupId = vm.selectedGroup.id;
                else
                    vm.formData.signUpConfiguration.groupId = null;
            };
            //prevents changing the URL to access the other steps
            $timeout(function () {
                if ($state.current.name.indexOf("step" + vm.step) === -1) {
                    $state.go("main.settings.addExternalLoginConfiguration.step" + vm.step);
                }
            });
            //$scope.$on("$viewContentLoaded", function () {
            //	if ($state.current.name.indexOf("step" + vm.step) === -1) {
            //		$state.go("main.settings.addExternalLoginConfiguration.step" + vm.step);
            //	}
            //});
            vm.goToStep = function (step) {
                if (vm.form.$valid || step === 2 || step < vm.step) {
                    vm.showErrors = false;
                    vm.step = step;
                    if (step === 3)
                        vm.nextButtonText = "common.confirm";
                    else
                        vm.nextButtonText = "common.next";
                    $state.go("main.settings.addExternalLoginConfiguration.step" + vm.step);
                }
                else {
                    vm.showErrors = true;
                }
            };
            vm.getMappedFields = function () {
                return _.map(vm.mappings, function (item) {
                    if (!item.to)
                        return "";
                    return $translate.instant("settings.registration.claim." + item.to);
                }).join(', ');
            };
            vm.selectProvider = function (provider) {
                vm.formData = angular.copy(provider);
                vm.formData.signUpConfiguration = {};
                if (provider.signUpConfiguration && provider.signUpConfiguration.authenticationTokenFieldMapping)
                    vm.mappings = _.map(provider.signUpConfiguration.authenticationTokenFieldMapping, function (key, value) { return { from: key, to: value }; });
                else
                    vm.mappings = [{ from: "", to: "" }];
                vm.formData.visible = true;
                vm.formData.enabled = true;
                vm.formData.signUpConfiguration.groupId = vm.selfRegistrationGroupId;
                vm.goToStep(2);
            };
            vm.editAuthenticationToken = function () {
                var modal = $uibModal.open({
                    templateUrl: "authtoken.tpl",
                    backdrop: "static",
                    controller: ["fieldsToMap", "mappings", function (fieldsToMap, mappings) {
                            var vm = this;
                            vm.mappings = angular.copy(mappings);
                            vm.fieldsToMap = fieldsToMap;
                            vm.add = function () {
                                if (vm.mappingsForm.$valid) {
                                    vm.mappings.push({ from: "", to: "" });
                                }
                            };
                            vm.remove = function (map) {
                                vm.mappings = _.without(vm.mappings, map);
                            };
                        }],
                    controllerAs: "vm",
                    resolve: {
                        fieldsToMap: function () { return vm.fieldsToMap; },
                        mappings: function () { return vm.mappings; }
                    }
                });
                modal.result.then(function (mappings) {
                    vm.mappings = mappings;
                }).catch(angular.noop);
            };
            vm.save = function () {
                if (vm.form.$valid) {
                    vm.formData.signUpConfiguration.authenticationTokenFieldMapping = _.reduce(_.map(vm.mappings, function (obj) { var newObj = {}; newObj[obj.to] = obj.from; return newObj; }), function (memo, obj) { return angular.extend({}, memo, obj); });
                    externalLoginConfigurationResource.save(vm.formData, function (result) {
                        vm.provider = result;
                        vm.goToStep(4);
                    }, function (error) {
                        messageService.error(error);
                    });
                }
            };
            vm.addExternalLogin = function () {
                $state.go("main.settings.addExternalLoginConfiguration.step1", {}, { reload: true });
            };
            vm.editExternalLogin = function (provider) {
                $state.go("main.settings.editExternalLoginConfiguration", provider);
            };
            vm.loadFromWellKnownFile = function () {
                vm.wellKnownInvalid = false;
                if (vm.wellKnownUrl.indexOf(".well-known") == -1) {
                    vm.wellKnownUrl += "/.well-known/openid-configuration";
                }
                $timeout(function () {
                    $http.get(vm.wellKnownUrl).then(function (result) {
                        if (!result.data.authorization_endpoint) {
                            vm.wellKnownInvalid = true;
                            return;
                        }
                        vm.formData.authorizationEndpoint = result.data.authorization_endpoint;
                        vm.formData.tokenEndpoint = result.data.token_endpoint;
                        vm.formData.userInfoEndpoint = result.data.userinfo_endpoint;
                        vm.formData.endSessionEndpoint = result.data.end_session_endpoint;
                        if (_.contains(result.data.claims_supported, 'sub')) {
                            vm.formData.idFieldName = 'sub';
                        }
                        vm.formData.scope = result.data.scopes_supported.join(' ');
                        vm.wellKnownUrl = '';
                        vm.wellKnownInvalid = false;
                    }, function () {
                        vm.wellKnownInvalid = true;
                    });
                });
            };
        }
    });
}());
